import { CONNECTION_TYPE_DAV } from '../../DataConnections/dataConnection.types';
import { paramSubmit, paramUrl } from '../constants/parameterNames';
import { typeDataConnection } from '../constants/parameterTypes';
import { success } from '../helpers/commandResult';
import { getParamValue } from '../helpers/parameter.accessors';
import { getDataConnection } from '../helpers/qRules.dataConnection.helpers';

const optionalParameters = [];
const requiredParameters = [
    {
        name: paramSubmit,
        description: 'Submit Adapter Name',
        type: typeDataConnection,
    },
    {
        name: paramUrl,
        description: 'Folder/library path to submit to',
    },
];

const description =
    'Modifies the URL in a SharePoint submit data connection so that forms submit to a different library by specifying /url. If the /url parameter is not specified (and the form is published to a SharePoint form library), it uses the library the form is opened from.';

function execute({ dataConnections, parameters }) {
    const submit = getParamValue(parameters, paramSubmit);
    const url = getParamValue(parameters, paramUrl);

    const conn = getDataConnection(dataConnections, submit);

    if (conn.type !== CONNECTION_TYPE_DAV) {
        throw new Error(
            'Data connection must be a SharePoint library submit connection.',
        );
    }

    conn.setUrl(url);

    return success(url);
}

const command = {
    description,
    execute,
    optionalParameters,
    requiredParameters,
};

export default command;
